// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QWB0","delete":"styles_delete__1Sq6y","update":"styles_update__3X6H0","add":"styles_add__3kX0J"};